import { z } from 'zod';
import { FFALicenseType } from '../../../Dashboard/Application/FFA/FFA';
import { SpecialFederationName } from '../SpecialFederationName/SpecialFederationName';
const GenericCheckoutReductionSchema = z.object({
    id: z.string(),
    amount: z.number(),
    amountType: z.enum(['FIXED', 'PERCENT']),
    attendeeId: z.string(),
    validFrom: z.coerce.date().nullable(),
    validUntil: z.coerce.date().nullable()
});
const LicensedCheckoutReductionSchema = GenericCheckoutReductionSchema.extend({
    reductionType: z.literal('LICENSED'),
    federationName: z.nativeEnum(SpecialFederationName).optional(),
    ffaLicenseTypes: z.array(z.nativeEnum(FFALicenseType)).optional()
});
const GenderCheckoutReductionSchema = GenericCheckoutReductionSchema.extend({
    reductionType: z.literal('GENDER'),
    gender: z.enum(['MALE', 'FEMALE'])
});
const MinorCheckoutReductionSchema = GenericCheckoutReductionSchema.extend({
    reductionType: z.literal('MINOR')
});
const AllCheckoutReductionSchema = GenericCheckoutReductionSchema.extend({
    reductionType: z.literal('ALL')
});
const GroupCheckoutReductionSchema = GenericCheckoutReductionSchema.extend({
    reductionType: z.literal('GROUP'),
    groupId: z.coerce.number()
});
export const CheckoutReductionSchema = z
    .object({ type: z.string() })
    .passthrough()
    .transform(({ type, ...rest }) => ({ reductionType: type, ...rest }))
    .pipe(z.discriminatedUnion('reductionType', [
    LicensedCheckoutReductionSchema,
    GenderCheckoutReductionSchema,
    MinorCheckoutReductionSchema,
    AllCheckoutReductionSchema,
    GroupCheckoutReductionSchema
]));
